export const sortFacetValues = (items, sortOrder) => {
    return items.sort(({ label: labelA }, { label: labelB }) => {
        const idxA = sortOrder.indexOf(labelA);
        const idxB = sortOrder.indexOf(labelB);
        return idxA === -1 ? 1 : idxB === -1 ? -1 : idxA - idxB;
    });
};
